import {
  compact as _compact,
  isBoolean as _isBoolean,
  isEmpty as _isEmpty,
  isNil as _isNil,
  isNumber as _isNumber,
  isString as _isString,
  map as _map,
  trim as _trim,
  uniq as _uniq,
} from 'lodash';

/**
 * the most terrible camelizer on the internet, guaranteed!
 * @param {string} str String that isn't camel-case, e.g., CAMeL_CaSEiS-harD
 * @return {string} String converted to camel-case, e.g., camelCaseIsHard
 */
function camelCase(str) {
  return `${str.charAt(0).toLowerCase()}${str.replace(/[\W_]/g, '|').split('|')
    .map(part => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join('')
    .slice(1)}`;
}

/**
 * Returns the document scroll position
 *
 * @return {number}
 */
function winScroll() {
  return (window.pageYOffset || document.documentElement.scrollTop);
}

/**
 * Returns the viewport height
 *
 * @return {number}
 */
function winHeight() {
  return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}

/**
 * Ensure some object is a coerced to a string
 *
 * @param {object} [object]
 * @return {string}
 */
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}

/**
 * Removes all html tags from a string.
 *
 * @param {string} [str]
 * @return {string}
 */
function stripTags(str) {
  return this.makeString(str).replace(/<\/?[^>]+>/g, '');
}

/**
 * Determine if the given value is "blank".
 *
 * @param {*} [value]
 * @return {boolean}
 */
function blank(value) {
  if (_isNil(value)) return true;
  if (_isString(value)) return _trim(value) === '';
  if (_isNumber(value) || _isBoolean(value)) return false;
  if (typeof value[Symbol.iterator] === 'function') return (value.length === 0);
  return _isEmpty(value);
}

/**
 * Determine if a value is "filled".
 *
 * @param {*} [value]
 * @return {boolean}
 */
function filled(value) {
  return !this.blank(value);
}

/**
 * Checks whether an URL is absolute or not
 *
 * @param {string} [str] The input string
 * @return {boolean}
 */
function isAbsoluteUrl(str) {
  const r = new RegExp('^(?:[a-z]+:)?//', 'i');
  return r.test(str);
}

/**
 * Replaces backslashes in a string with forward slashes
 *
 * @param {string} [str] Input string
 * @return {string} The replaced string, else the original input
 */
function backslash2slash(str) {
  return (_isString(str) ? str.replace(/\\/g, '/') : str);
}

/**
 * Collects each line of a multiline string in an array
 *
 * @param {string} [str] The input string
 * @param {boolean} [duplicates] Keep duplicate lines
 * @param {boolean} [empty] Keep empty lines
 * @return {array|null} The result array, else null
 */
function linesToArray(str, duplicates = false, empty = false) {
  if (!_isString(str) || this.blank(str)) return null;
  str = _trim(str);
  let lines = str.split(/\r\n|\r|\n/);
  lines = _map(lines, _trim);
  if (!duplicates) lines = _uniq(lines);
  if (!empty) lines = _compact(lines);
  return lines;
}

/**
 * Sorts an array of numeric values in ascending or descending order
 *
 * @param {array} [arr] The array to sort
 * @param {boolean} [desc] Sort in descending order
 * @return {array} The sorted array
 */
function sortNumeric(arr, desc = false) {
  if (!desc) {
    return arr.sort((a, b) => a - b);
  } else {
    return arr.sort((a, b) => b - a);
  }
}

export default {
  camelCase,
  winScroll,
  winHeight,
  makeString,
  stripTags,
  blank,
  filled,
  isAbsoluteUrl,
  backslash2slash,
  linesToArray,
  sortNumeric,
};
